import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MediaComponent} from './media/media.component';
import {PostComponent} from './post/post.component';

const routes: Routes = [
  { path: '', component: MediaComponent},
  { path: 'post', component: PostComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// E:/UniServerZ/www/seo/wp-content/plugins/dvin508-ada-seo/seo/src/app/app-routing.module.ts